import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

export default function Timer({ initialSeconds, initialMinute }) {
  const [minutes, setMinutes] = useState(initialMinute);
  const [seconds, setSeconds] = useState(initialSeconds);
  const [finish, setFinish] = useState(false);

  useEffect(() => {
    if (finish) return;

    const myInterval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        } else {
          // seconds === 0
          setMinutes((prevMinutes) => {
            if (prevMinutes === 0) {
              setFinish(true);
              return 0;
            } else {
              return prevMinutes - 1;
            }
          });
          return 59;
        }
      });
    }, 1000);

    return () => clearInterval(myInterval);
  }, [finish]);

  return (
    <Box display="flex">
      {!finish && (
        <>
          <Typography fontSize="14px" color="var(--emr-primary)" ml="5px">
            {"ارسال مجدد کد تایید"}
          </Typography>
          {minutes === 0 && seconds === 0 ? null : (
            <Typography fontSize="14px" color="var(--emr-primary)">
              {"("}
              {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
              {")"}
            </Typography>
          )}
        </>
      )}
      {finish && (
        <>
          <Typography sx={{ fontSize: "16px", color: "var(--emr-text-bold)" }}>
            کد تایید دریافت نکردید؟
          </Typography>
          <Typography
            sx={{
              fontSize: "16px",
              color: "var(--emr-primary)",
              mr: "5px",
              cursor: "pointer",
            }}
            onClick={() => {
              // Reset timer
              setMinutes(initialMinute);
              setSeconds(initialSeconds);
              setFinish(false);
            }}
          >
            ارسال مجدد کد
          </Typography>
        </>
      )}
    </Box>
  );
}
